import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const reassurances = ['Descarga instantánea tras el pago', 'Un solo pago, sin cuotas mensuales', 'Acceso de por vida con actualizaciones', 'Garantía de 7 días sin preguntas'];
export function Offer() {
  return <section id="offer" className="relative w-full overflow-hidden bg-ink px-5 py-20 sm:py-28" data-id="element-167" data-mp="tyldvjafzypx">
      <div className="bg-stripes absolute inset-0" aria-hidden="true" data-id="element-168" data-mp="ozs1xvat0frv" />
      <div className="relative mx-auto max-w-xl" data-id="element-169" data-mp="p1uzd0eadb6m">
        <Reveal className="text-center" data-id="element-170" data-mp="13xavrc2c9j66">
          <span className="inline-flex rounded-full bg-volt px-4 py-1.5 font-display text-xs tracking-[0.16em] text-ink" data-id="element-171" data-mp="13ycabqikcnsn">
            Oferta especial de lanzamiento
          </span>
          <h2 className="balance mt-6 font-display text-[2.4rem] leading-[0.98] text-white sm:text-[3.4rem]" data-id="element-172" data-mp="2famsz43lf3jd">
            Kit Educación Física Lista™{' '}
            <span className="text-brand" data-id="element-173" data-mp="pkh4r5ywamdk">completo</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-174" data-mp="ujbm03h7s2vk">
          <div className="relative mt-12 rounded-3xl border-2 border-ink bg-white px-6 pb-8 pt-12 shadow-lift sm:px-9" data-id="element-175" data-mp="uiipdvbyytr5">
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border-2 border-ink bg-brand px-5 py-1.5 font-display text-xs tracking-[0.14em] text-white" data-id="element-176" data-mp="zjpufmmq9eu4">
              12 volúmenes + 5 bonos
            </span>

            <dl data-id="element-177" data-mp="bski3hfzx4ok">
              {offerRows.map(row => <div key={row.label} className="flex items-start justify-between gap-4 border-b border-ink/10 py-4" data-id="element-178" data-mp="btlubp8qzx7v">
                  <dt className="text-base leading-snug text-ink/75" data-id="element-179" data-mp="ft4egisqw49n">
                    {row.label}
                  </dt>
                  <dd className="shrink-0 font-bold text-ink/40 line-through" data-id="element-180" data-mp="kmysp6pkzr1c">
                    {row.value}
                  </dd>
                </div>)}
              <div className="flex items-center justify-between gap-4 border-b-2 border-ink py-4" data-id="element-181" data-mp="3o8wgoymf47um">
                <dt className="font-display text-lg text-ink" data-id="element-182" data-mp="vefsi01qy101">Valor total</dt>
                <dd className="shrink-0 font-display text-lg text-ink/40 line-through" data-id="element-183" data-mp="qhflnmx2ou7v">
                  $110.000
                </dd>
              </div>
            </dl>

            <p className="mt-8 text-center font-display text-sm tracking-[0.18em] text-brand" data-id="element-184" data-mp="106gzp7k251j7">
              Solo por hoy
            </p>
            <p className="mt-2 text-center" data-id="element-185" data-mp="chxskvcquusp">
              <span className="font-display text-[4.5rem] leading-none text-ink sm:text-[5.5rem]" data-id="element-186" data-mp="cippqalzp0l3">
                $19.990
              </span>
              <span className="mt-2 block text-sm font-bold uppercase tracking-[0.16em] text-ink/50" data-id="element-187" data-mp="lht6v91lj5wy">
                ARS · un solo pago
              </span>
            </p>

            <CtaButton label="Quiero mi Kit ahora" className="mt-8 w-full" data-id="element-188" data-mp="1wwg8n344e22b" />

            <p className="mt-4 flex items-center justify-center gap-2 text-xs text-ink/50" data-id="element-189" data-mp="1wykmacrtmffs">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-190" data-mp="1sx7f9zczs67a" />
              <span data-id="element-191" data-mp="20dule55n4bjx">Pago seguro con</span>
              <span className="font-bold text-[#009ee3]" data-id="element-192" data-mp="20h05f5zewn8s">Mercado Pago</span>
            </p>

            <ul className="mt-6 space-y-2.5" data-id="element-193" data-mp="25bdwwxayea86">
              {reassurances.map(item => <li key={item} className="flex items-center gap-2.5 text-sm font-semibold text-ink/70" data-id="element-194" data-mp="1qi0ybruaoznw">
                  <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-volt" data-id="element-195" data-mp="1vft1ji0e487e">
                    <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" strokeWidth={3} data-id="element-196" data-mp="2j784nczzqtjp" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}